export default {
  mailContact: 'Me gustaría que me contacten por correo electrónico',
  subTitle: 'Para acceder a la demo es necesario que completes todos los campos.',
  schoolAddressPlaceholder: 'Escribe la dirección de tu escuela',
  schoolAddress: 'Dirección de la escuela',
  takeAdvantage: 'Aprovecha Kimple al máximo',
  inviteFourColleagues: 'Puedes invitar hasta <span class="bold text-big dark-gray">4 colegas de tu Escuela</span> para que disfruten juntos la plataforma.',
  invite: 'Invitar',
  inviteColleagues: 'Invita a tus colegas',
  teachersLabel: 'Aún no hay equipo asignado a esta escuela',
  managersLabel: 'Aún no hay directivos asignados a esta escuela',
  disabledOnTrial: 'No disponible en trial',
  trialFinished: 'Tu período de prueba ha terminado. Consigue un nuevo plan.',
  done: 'Listo'
}

export const en = {
  mailContact: 'I\'d like to be reached via email',
  subTitle: 'To access the demo you need to fill in the fields.',
  schoolAddressPlaceholder: 'Enter the school address',
  schoolAddress: 'School address',
  takeAdvantage: 'Make the most of Kimple',
  inviteFourColleagues: 'You can invite up to <span class="bold text-big dark-gray">4 School colleagues</span> so you can enjoy the platform together.',
  invite: 'Invite',
  inviteColleagues: 'Invite colleagues',
  teachersLabel: 'No team has been assigned to this school yet',
  managersLabel: 'No managers have been assigned to this school yet',
  disabledOnTrial: 'Unavailable in trial',
  trialFinished: 'Your trial period is over. Get a new plan.',
  done: 'Done'
}

export const ca = {
  mailContact: 'M\'agradaria que em contactin per correu electrònic',
  subTitle: 'Per accedir a la prova has d\'omplir tots els camps.',
  schoolAddressPlaceholder: 'Escriu l\'adreça de la teva escola',
  schoolAddress: 'Direcció de l\'escola',
  takeAdvantage: 'Aprofita Kimple al màxim',
  inviteFourColleagues: 'Pots convidar fins a  <span class="bold text-big dark-gray">4 companys de la teva Escol</span> per aprofitar junts la plataforma.',
  invite: 'Convida',
  inviteColleagues: 'Convida els teus companys',
  teachersLabel: 'Encara no hi ha cap equip assignat a aquesta escola',
  managersLabel: 'Encara no hi ha directius assignats a aquesta escola',
  disabledOnTrial: 'No disponible en període de prova',
  trialFinished: 'El teu període de prova ha acabat. Aconsegueix un nou pla.',
  done: 'Fet'
}
